module.exports = __webpack_public_path__ + "static/media/shangye.57cca905.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageSecureSmartLock/shangye.png
// module id = 617
// module chunks = 0